export default function Zapier({ userEmail, firstName, lastName }) {
  return (
    <div className="w-full">
      <div className="mb-6">
        <h1 className="text-xl font-semibold leading-6 text-gray-900">Zapier Integration</h1>
        <p className="mt-2 text-sm text-gray-700">
          Connect your account with thousands of apps through Zapier. Create automated workflows
          to streamline your data extraction process.
        </p>
      </div>
      
      <zapier-workflow
        sign-up-email={userEmail}
        sign-up-first-name={firstName}
        sign-up-last-name={lastName}
        client-id="rSXz6WwFtLLshVtuCeDpXm34Fqx2umxyiz0eZQOB"
        theme="light"
        intro-copy-display="show"
        manage-zaps-display="hide"
        guess-zap-display="show"
        template-cta-display="show"
        zap-create-from-scratch-display="hide"
      />
    </div>
  );
}

